import React, {useEffect, useState} from 'react';
import {WdiGridApp} from '@/components/WdiBus/PanelForWarning';
import {wdiCore} from '@/components/GridWidget';
import {FormSaMkt} from "@/services/mkt/sa";
import {ColumnsType} from "antd/lib/table";

const SaBudgetSubmit: Record<string, any> = {
  bohqId: (_: any, record: any) => {
    return record['bohqName'];
  },
  ecMktId: (_: any, record: any) => {
    return record['ecMktName'];
  },
  productCode: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productCode'], record['productName']);
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountApproved: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproved'], 2);
  },
  amountUsaged: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountUsaged'], 2);
  },
  amountRemain: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    if (record['amount'] > record['amountRemain']) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amount'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  amountNonTpm: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountNonTpm'], 2);
  },
  rowNumbers: (_: any, record: any) => {
    if (record['amount'] > record['amountRemain']) {
      return <span style={{color: '#ff0000'}}>{record['rowNumbers']}</span>;
    }
    return record['rowNumbers'];
  },
};

const SaMktBudget: Record<string, any> = {
  bohqId: (_: any, record: any) => {
    return record['bohqName'];
  },
  ecMktId: (_: any, record: any) => {
    return record['ecMktName'];
  },
  productCode: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productCode'], record['productName']);
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountApproved: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproved'], 2);
  },
  amountUsaged: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountUsaged'], 2);
  },
  amountRemain: (_: any, record: any) => {
    if (record['amountRemain'] < 0) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amountRemain'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  amountNonTpm: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountNonTpm'], 2);
  },
  rowNumbers: (_: any, record: any) => {
    return record['rowNumbers'];
  },
};
const columnsRenders: Record<string, Record<string, any>> = {
  SaBudgetSubmit: SaBudgetSubmit,
  SaMktBudget: SaMktBudget,

};
const BudgetInformation: React.FC<{ formId?: number }> = (props) => {
  const [budgetInfos, setBudgetInfos] = useState<API.WdiGrid[]>([]);

  useEffect(() => {
    (async () => {
      if (props.formId) {
        const response = await FormSaMkt.Buttons.budgetInfos(props.formId);
        setBudgetInfos(response.data.items);
      }
    })();
  }, [props.formId]);

  const renderWdiGridApp = (props: API.WdiGrid) => {
    const columns: ColumnsType<any> = [];
    const columnsRender = columnsRenders[props.key];
    props.wdiColumns.map((wdiColumn) => {
      if (!wdiColumn.isHidden) {
        const column: any = {
          title: wdiColumn.displayName,
          dataIndex: wdiColumn.name,
          width: wdiColumn.width,
          ellipsis: true,
          //render: FormBudgetInfo[wdiColumn.name]
        };
        if (columnsRender && columnsRender[wdiColumn.name]) {
          column.render = columnsRender[wdiColumn.name];
        }
        columns.push(column);
      }
    });

    return (
      <WdiGridApp
        key={props.key}
        wdiGrid={props}
        columns={columns}
        dataSource={props.items}
      />
    );
  };

  return (
    <>
      {budgetInfos.map((item) => {
        return (
          renderWdiGridApp(item)
        );
      })}
    </>
  );
};

export default BudgetInformation;
